import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CMPFormInputText from '../../../../common/Forms/CMPFormTextField';
import CMPInputDropdown from '../../../../common/Forms/CMPInputDropdown';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCommunityBasedProvider,
  setParticipant1,
  setParticipant4,
  setCss1,
  setCss4,
  setScss1,
  setScss4,
  setRvwDate1,
  setRvwDate4,
} from '../../../../../redux/episode/cmpTab/cmpForm/cmpSlice';

const Section1 = (props) => {
  const dispatch = useDispatch();
  const { control, defaultValue, register, errors } = props;

  const cmpReferenceData = useSelector((state) => state.cmpReferenceData);

  const {
    firstParticipantList,
    participantList,
    communityBasedProviderList,
    cssOrScssList,
  } = cmpReferenceData;

  return (
    <Grid item xs={12} sm={4}>
      <CMPInputDropdown
        name='participant1'
        control={control}
        options={firstParticipantList}
        defaultId={defaultValue?.participant1}
        register={register('participant1', {
          onChange: (e) => dispatch(setParticipant1(e.target.value)),
        })}
        label='Participant'
      />
      <CMPInputDropdown
        name='css1'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.css1}
        cssOrScssList={true}
        register={register('css1', {
          onChange: (e) => dispatch(setCss1(e.target.value)),
        })}
        label='Css'
      />
      <CMPInputDropdown
        name='scss1'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.scss1}
        cssOrScssList={true}
        register={register('scss1', {
          onChange: (e) => dispatch(setScss1(e.target.value)),
        })}
        label='Scss'
      />
      <CMPFormInputText
        name='rvwDate1'
        type='date'
        control={control}
        shrink={true}
        register={register('rvwDate1', {
          onBlur: (e) => dispatch(setRvwDate1(e.target.value)),
        })}
        label='Date'
        mini={true}
      />
      <CMPInputDropdown
        name='participant4'
        control={control}
        options={firstParticipantList}
        defaultId={defaultValue?.participant4}
        register={register('participant4', {
          onChange: (e) => dispatch(setParticipant4(e.target.value)),
        })}
        label='Participant'
      />
      <CMPInputDropdown
        name='css4'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.css4}
        cssOrScssList={true}
        register={register('css4', {
          onChange: (e) => dispatch(setCss4(e.target.value)),
        })}
        label='Css'
      />
      <CMPInputDropdown
        name='scss4'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.scss4}
        cssOrScssList={true}
        register={register('scss4', {
          onChange: (e) => dispatch(setScss4(e.target.value)),
        })}
        label='Scss'
      />
      <CMPFormInputText
        name='rvwDate4'
        type='date'
        control={control}
        shrink={true}
        register={register('rvwDate4', {
          onBlur: (e) => dispatch(setRvwDate4(e.target.value)),
        })}
        label='Date'
      />
      <hr />
      <Box mt={2}>
        <CMPInputDropdown
          name='communityBasedProvider'
          control={control}
          options={communityBasedProviderList}
          defaultId={defaultValue?.communityBasedProvider}
          errors={!!errors.communityBasedProvider}
          helperText={errors?.communityBasedProvider?.message}
          register={register('communityBasedProvider', {
            onChange: (e) => dispatch(setCommunityBasedProvider(e.target.value)),
          })}
          label='CBP'
        />
      </Box>  
    </Grid>
  );
};

export default Section1;
